$(function () {
    var $body = $('#js-letters-article-body');
    if ($body.length < 1) {
        return;
    }
    $body.find('a[target="_blank"]').each(function(){
        var $this = $(this);
        var text = $this.text();
        $this.html('<span>'+ text + '</span>');
    });
});


/*****************
 ** WEBPACK FOOTER
 ** ./src/pc/js/module/entryFilter.js
 ** module id = 2
 ** module chunks = 2
 **/